import type { CSSProperties } from 'react';

import './DynaLoader.css';

export type DynaLoaderVariant = 'inline' | 'small' | 'block' | 'artwork';

/**
 * Five bars evenly spaced around the circle -- 36 degrees apart, so the ten
 * rays are symmetric about the centre -- one colour each, sweeping the
 * artwork's palette as they go round.
 */
const Bars = [
  { angle: '0deg', colour: '#FF2D55' },
  { angle: '36deg', colour: '#FFD400' },
  { angle: '72deg', colour: '#00FF8B' },
  { angle: '108deg', colour: '#00E5FF' },
  { angle: '144deg', colour: '#B026FF' },
];

const VariantClassNames: Record<DynaLoaderVariant, string> = {
  inline: 'dynaLoaderInline',
  small: 'dynaLoaderSmall',
  block: 'dynaLoaderBlock',
  artwork: 'dynaLoaderArtwork',
};

interface DynaLoaderProps {
  variant?: DynaLoaderVariant;
  /** Announced to screen readers in place of the bars. */
  label?: string;
}

const DynaLoader = ({ variant = 'block', label = 'Loading' }: DynaLoaderProps) => {
  return (
    <span className={`dynaLoader ${VariantClassNames[variant]}`} role="status" aria-label={label}>
      {Bars.map((bar, index) => (
        <span
          key={index}
          className="dynaLoaderBar"
          style={{
            '--dynaBarIndex': index,
            '--dynaBarAngle': bar.angle,
            '--dynaBarColour': bar.colour,
          } as CSSProperties}
        />
      ))}
    </span>
  );
}

export default DynaLoader;
